const icon1 =
  "https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2021/12/Picture1aa.jpg";
const icon2 = "https://winpeforum.com/assets/elements/ZiaMody_edit.jpg";
const icon4 = "https://winpeforum.com/assets/elements/Renuka-Ramnath.png";
const icon3 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";
const icon5 = "https://winpeforum.com/assets/elements/esterNew.jpg";
const icon6 = "https://winpeforum.com/assets/elements/matangi.jpg";
const icon7 = "https://winpeforum.com/assets/elements/shyamala.jpg";
const iconnewteam1 = "https://winpeforum.com/assets/elements/TinaAhluwalia.jpg";
const iconnewteam2 = "https://winpeforum.com/assets/elements/AyushiVedwan.png";
const iconnewteam3 = "https://winpeforum.com/assets/elements/PalakPatel.jpg";
const iconnewteam4 = "https://winpeforum.com/assets/elements/VijaytaMahendru.png";
const iconnewteam5 = "https://winpeforum.com/assets/elements/SudhanshuKhurana.jpg";
const iconnewteam6 = "https://winpeforum.com/assets/elements/PrernaJain.jpg";
const iconnewteam7 = "https://winpeforum.com/assets/elements/Purnima.png"; 
const iconnewteam8 = "https://winpeforum.com/assets/elements/DeekshaJain.png"; 
const iconnewamb1 = "https://winpeforum.com/assets/ambassadors/KaushalyaVenkataraman.png";
const iconnewamb2 = "https://winpeforum.com/assets/ambassadors/PratitiDasgupta.png";
const iconnewamb3 = "https://winpeforum.com/assets/ambassadors/NupurNataraja.png";
const iconnewamb5 = "https://winpeforum.com/assets/ambassadors/SheetalTrivedi.png";
const iconnewamb4 = "https://winpeforum.com/assets/ambassadors/KanakHeda.png";
const iconnewamb6 = "https://winpeforum.com/assets/ambassadors/CheshtaVashishth.png";

const team_constants = [
   
  {
    imgUrl: icon3,
    // into:"Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ’s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy.",
    desc: `<div>Anita has been an investor backing early trends with winning partners and established a distinguished track record in sustainable investments across the globe. In her last five and a half years with CDPQ, she established CDPQ's office in India and soon after became Executive Vice President and Head of Emerging Markets at CDPQ. Her final post at CDPQ was as Executive Vice President and Deputy Head of CDPQ Global covering all geographies outside of Canada, supporting investments in renewable energy, highways, telecom, and venture fund investments in Emerging Markets. Anita spent 22 years at the World Bank Group with 14 of those years with the IFC in Infrastructure and Natural Resources, Municipal Finance and initiated the creation of IFC's Venture group. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.
   <br/><Br/>
    Ms. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.
				</div>`,
    name: "Anita George",
    post: `<div>Member, Advisory Board, Winpe<br/>Global Sustainable Investment Professional</div>`,
    link: "https://www.linkedin.com/in/anita-george-255778133/",
  },
  {
    imgUrl: icon4,
    // into:"Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance.",
    desc: `<div>Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance. 
		<br />
		<br />
		For close to three decades in financial services, Renuka successfully built several businesses in the ICICI Group including Investment Banking, e-commerce and private equity. As the MD & CEO of ICICI Venture for close to a decade, she led that firm to become one of the largest private equity funds in India.
		<br />
		<br />
		She is a Board member of EMPEA, the global industry association for private capital in emerging markets. She is also the Chairperson of the Executive Committee of  Indian Venture Capital Association.  Renuka has been featured in many prestigious listings, including the Top 25 Most Powerful Women in Business (Business Today, India); India's most Powerful CEO's (Economic Times), the Top 25 Non Bank Women in Finance (US Banker's global list), Asia's Women in the Mix: The Year's Top 50 for Achievement in Business (Forbes), Top 25 women in Asian asset management (Asian Investor) and most recently has been awarded the AVCJ Special Achievement Award, 2019.
		</div>`,
    name: "Renuka Ramnath",
    post: `<div>Member, Advisory Board, Winpe <br /> Founder, MD & CEO, Multiples Alternate Asset Management</div>`,
    link: "https://www.linkedin.com/in/renukaramnath/",
  },
   {
    imgUrl: icon2,
    // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
    name: "Zia J. Mody",
    desc: `<div>Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011. 
		<br />
		<br />
		Zia has held and continues to hold several prestigious positions at global and national levels. She currently serves as a Member, Governing Board – International Council for Commercial Arbitration (ICCA) and Member – CII National Council. She was the Vice President & Member – London Court of International Arbitration (LCIA) and Member – World Bank Administrative Tribunal, Washington D.C.. In addition, Zia has served in various capacities on several committees and panels set up by Indian regulatory bodies including SEBI, RBI, Law Commission of India and Ministry of Corporate Affairs.
		<br />
		<br />
		Zia has been a recipient of numerous awards recognizing her individual and professional achievements as a legal practitioner and leader. She completed her masters in law from the Harvard Law School and is a member of the New York State Bar Association. Zia’s practice areas include Mergers & Acquisitions, Private Equity, Restructuring and General Corporate, Compliance & Investigation, Dispute Resolution, and Regulatory & Securities Law.
		</div>`,
    post: `<div>Member, Advisory Board, Winpe <br /> Co–Founder & Managing Partner, AZB & Partners</div>`,
    link: "https://www.linkedin.com/in/ziamody",
  },
  
  {
    imgUrl: icon6,
    // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
    name: "Matangi Gowrishankar",
    desc: `<div>Ms. Matangi Gowrishankar brings more than three decades of experience as a business, Human Resources and Change Management specialist. Passionate about leadership and organization development she has a track record in organization transformation and talent management both in India and overseas.
		<br />
		<br />
		She has worked with several large multinational organizations like Standard Chartered Bank, Reebok, GE, Cummins Inc and most recently, with the British Oil Major BP plc where her last assignment was Global Head of Capability Development and Director of the Leadership Academy. She has extensive, diverse experience having lived and worked in the UK and Singapore with a broad geographical remit across several countries.
		<br />
		<br />
		Ms. Gowrishankar has a BA in Sociology and a Post Graduate qualification in Human Resources from XLRI, a premier educational institution in India. She is a certified coach from the Neuroleadership Group (previously Results Coaching) Australia. Ms. Gowrishankar also holds certifications from SHL (Saville & Holdsworth) for designing and conduct of Assessment Centres, Instructional Design and Facilitation Skills from Skill Base UK.
		<br />
		<br />
		Today, with an independent organization development practice, Ms. Gowrishankar continues to work with BP and other organizations coaching, guiding and facilitating leaders to transform self and the organization to meet the challenges of doing business in a highly volatile and dynamic environment. She has experience in leading several D&I initiatives including highly successful development offers for women both in India and overseas. Her credo is to make a positive difference to individuals and organizations. She believes in enduring partnerships built on trust and mutual respect. She is committed to leveraging diversity of thought and the human spirit for achieving the best outcomes.
		<br />
		<br />
		Ms. Gowrishankar also holds Non - Executive Independent Directorships with 8 companies in India across diverse industries.
		<br />
		<br />
		She has been a regular speaker at Indian and global conferences and has contributed to several case study commentaries in Indian business magazines.
		<br />
		<br />
		Ms. Gowrishankar and her mother live in Pune, India. Her son, an event management specialist lives in Melbourne, Australia.
		</div>`,
    post: `<div>Member, Advisory Board, Winpe Proclub <br /> Independent Director, Strategic Advisor & Certified Coach</div>`,
    link: "https://www.linkedin.com/in/matangi-gowrishankar-0814a74/",
  },
  
    {
    imgUrl: icon7,
    // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
    name: "Shyamala Gopinath",
    desc: `<div>Ms. Shyamala Gopinath has 41 years of rich experience in financial sector policy formulation in different capacities at Reserve Bank of India (RBI). At RBI, she held key positions and guided & influenced national policies in diverse areas of financial sector regulation and supervision, the development and regulation of financial markets, capital account management, management of government borrowings, foreign exchange reserve management and payment and settlement systems.
		<br />
		<br />
		She has served on several committees while with RBI. During 2001 to 2003, she was deputed as Senior Financial Expert at the International Monetary Fund. Ms. Gopinath retired as Deputy Governor of RBI, a position that she held for nearly 7 years. She served as Chairperson Advisory Board on Bank, Commercial and Financial Frauds for two years from 2012 to 2014.
		<br />
		<br />
		Ms. Gopinath was also the Chairperson of the Board of Corporate Bonds and Securitisation Advisory Committee of SEBI.
		<br />
		<br />
		Since 2012, Ms. Gopinath has held several Board positions in large corporates and public sector undertakings such as Clearing Corporation of India, Indian Oil Corporation Limited, GAIL and Ernst & Young (Global Governance Council). Presently, Ms. Gopinath serves as Independent Director on the Boards of other renowned companies. She is a part-time Non-Executive Chairperson of HDFC Bank Ltd. and Chairperson of the Board of Governors of Indian Institute of Management, Raipur.
		</div>`,
    post: `<div>Member, Advisory Board, Winpe Proclub <br /> Non-Executive Chairperson, HDFC Bank Ltd</div>`,
    link: "https://www.linkedin.com/in/shyamala-gopinath-21b41578/",
  },
 
  

  // {
  // 	imgUrl: icon5,
  // 	// into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
  // 	name:"Ester Martinez",
  // 	desc: `<div>Ms. Ester Martinez is the CEO & Editor-in-Chief at People Matters, the fastest-growing community for CHROs and business leaders committed to the advancement of talent & work practices for sustainable business impact.
  // 	<br />
  // 	<br />
  // 	In 2009, upon sensing the need for a platform to deliberate on talent management, leadership and hold critical insights on people & future of work for C-suite audience, Ms. Martinez founded People Matters and rapidly grew it to become one of the few successes in independent publishing and a brand synonymous to knowledge and digital innovation in people and work-tech space. And today the brand is a name to reckon with not just in India, but also globally, with a special focus on Southeast Asia.
  // 	<br />
  // 	<br />
  // 	A people’s person at heart, Ms. Martinez holds a Postgraduate degree in Human Resources Management from EADA (Spain) and a Master of Business Administration from Indian School of Business (ISB), Hyderabad.
  // 	<br />
  // 	<br />
  // 	With more than 15 years of experience in human resources, Ms. Martinez has a wealth of knowledge in the areas of talent, learning & development and work-tech. Until 2008, she worked as a professional manager with a host of blue chip companies such as Hewlett Packard and Tata Consultancy Services, both in India and the UK.
  // 	<br />
  // 	<br />
  // 	A much sought-after speaker on leadership and future of work, Ms. Martinez was recognized as a top influencer on employee engagement by The Employee Engagement Awards, and top influencer in HR Technology by Recruiting Daily. Ms. Martinez was also featured in the 2016 & 2018 LinkedIn Top Voices List, which ranks the top writers on LinkedIn for the year. She is also a renowned TEDx speaker and was nominated for the Global Employee Engagement Influencers 2017.
  // 	</div>`,
  // 	post:`</div>Member, Advisory Board, Winpe Proclub <br />CEO & Editor-in-Chief, People Matters</div>`,
  // 	link:"https://www.linkedin.com/in/estermartinez/"
  // },
  // {
  // 	imgUrl: icon6,
  // 	// into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
  // 	name:"Matangi Gowrishankar",
  // 	desc: `<div>Ms. Matangi Gowrishankar brings more than three decades of experience as a business, Human Resources and Change Management specialist. Passionate about leadership and organization development she has a track record in organization transformation and talent management both in India and overseas.
  // 	<br />
  // 	<br />
  // 	She has worked with several large multinational organizations like Standard Chartered Bank, Reebok, GE, Cummins Inc and most recently, with the British Oil Major BP plc where her last assignment was Global Head of Capability Development and Director of the Leadership Academy. She has extensive, diverse experience having lived and worked in the UK and Singapore with a broad geographical remit across several countries.
  // 	<br />
  // 	<br />
  // 	Ms. Gowrishankar has a BA in Sociology and a Post Graduate qualification in Human Resources from XLRI, a premier educational institution in India. She is a certified coach from the Neuroleadership Group (previously Results Coaching) Australia. Ms. Gowrishankar also holds certifications from SHL (Saville & Holdsworth) for designing and conduct of Assessment Centres, Instructional Design and Facilitation Skills from Skill Base UK.
  // 	<br />
  // 	<br />
  // 	Today, with an independent organization development practice, Ms. Gowrishankar continues to work with BP and other organizations coaching, guiding and facilitating leaders to transform self and the organization to meet the challenges of doing business in a highly volatile and dynamic environment. She has experience in leading several D&I initiatives including highly successful development offers for women both in India and overseas. Her credo is to make a positive difference to individuals and organizations. She believes in enduring partnerships built on trust and mutual respect. She is committed to leveraging diversity of thought and the human spirit for achieving the best outcomes.
  // 	<br />
  // 	<br />
  // 	Ms. Gowrishankar also holds Non - Executive Independent Directorships with 8 companies in India across diverse industries.
  // 	<br />
  // 	<br />
  // 	She has been a regular speaker at Indian and global conferences and has contributed to several case study commentaries in Indian business magazines.
  // 	<br />
  // 	<br />
  // 	Ms. Gowrishankar and her mother live in Pune, India. Her son, an event management specialist lives in Melbourne, Australia.
  // 	</div>`,
  // 	post: `<div>Member, Advisory Board, Winpe Proclub <br /> Independent Director, Strategic Advisor & Certified Coach</div>`,
  // 	link:"https://www.linkedin.com/in/matangi-gowrishankar-0814a74/"
  // },
  // {
  // 	imgUrl: icon7,
  // 	// into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
  // 	name:"Shyamala Gopinath",
  // 	desc: `<div>Ms. Shyamala Gopinath has 41 years of rich experience in financial sector policy formulation in different capacities at Reserve Bank of India (RBI). At RBI, she held key positions and guided & influenced national policies in diverse areas of financial sector regulation and supervision, the development and regulation of financial markets, capital account management, management of government borrowings, foreign exchange reserve management and payment and settlement systems.
  // 	<br />
  // 	<br />
  // 	She has served on several committees while with RBI. During 2001 to 2003, she was deputed as Senior Financial Expert at the International Monetary Fund. Ms. Gopinath retired as Deputy Governor of RBI, a position that she held for nearly 7 years. She served as Chairperson Advisory Board on Bank, Commercial and Financial Frauds for two years from 2012 to 2014.
  // 	<br />
  // 	<br />
  // 	Ms. Gopinath was also the Chairperson of the Board of Corporate Bonds and Securitisation Advisory Committee of SEBI.
  // 	<br />
  // 	<br />
  // 	Since 2012, Ms. Gopinath has held several Board positions in large corporates and public sector undertakings such as Clearing Corporation of India, Indian Oil Corporation Limited, GAIL and Ernst & Young (Global Governance Council). Presently, Ms. Gopinath serves as Independent Director on the Boards of other renowned companies. She is a part-time Non-Executive Chairperson of HDFC Bank Ltd. and Chairperson of the Board of Governors of Indian Institute of Management, Raipur.
  // 	</div>`,
  // 	post: `<div>Member, Advisory Board, Winpe Proclub <br /> Non-Executive Chairperson, HDFC Bank Ltd</div>`,
  // 	link:"#"
  // },
];

const team_constants1 = [
  {
    imgUrl: icon1,
    // into:"Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. Nupur’s experience spans private equity investing, operations and finance in leading global organizations like IFC – an arm of the World Bank Group, Discovery Networks and PwC.",
    desc: `<div> Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. She is the founder of Winpe (https://winpeforum.com), an initiative to
    enhance gender diversity in the investing ecosystem.<br/><br/>
    
    
    Nupur serves as Chairperson of the board of Kids Clinic India Limited and an independent director on the boards of companies including Edelweiss Real Assets Managers Limited, Kerala Infrastructure Fund Management Limited and SIDBI, the Indian development finance institution. She is an independent member of the investment committee at the Fund of Funds managed by the National Investment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government of India, and an advisor to and a member of the investment committee for the Dutch Good Growth Fund (DGGF) investment funds mandate given by the Dutch government for investments in SMEs in frontier markets across 75 countries. She has served as an external expert on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for investing in the Indian start-up ecosystem. Nupur advises select fund managers on a confidential basis on matters related to institutionalization, best practices and governance. She also mentors female entrepreneurs across various platforms.
    <br/><br/>
    
    Nupur is recognized as a thought and industry leader with a long list of recognitions that include the
    HerPower Award 2023, BW VC World Most Influential Women 2023 and 2022, Forbes W-Power list of
    Self Made Women 2020, India’s top 10 Women Leaders in Finance (AIWMI 2019), Vedica Women’s
    Alliance’s Women Leader in D&I 2022, Women Empowerment Entrepreneur Award 2019-20 and the
    Business Excellence and Innovative Best Practices - Academia Award 2019.
    <br/><br/>
    
    Prior to starting her entrepreneurial journey, Nupur led the private equity and venture capital funds
    business in the region for IFC and is widely credited with establishing IFC’s brand and credibility as one
    of the most respected institutional investors in this space. Under her stewardship, the portfolio doubled in
    size and returns, moving from a negative IRR to delivering gains for the first time in its history.
    <br/><br/>
    
    Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from
    Harvard Business School.
    
    <br/><br/>
    Nupur loves to spend time with her mother, husband and 8-year-old son, travel to new places, read and
    do 1500-piece puzzles.
				</div>`,
    name: "Nupur Garg",
    post: `<div>Founder, Winpe <br /> Investor & Independent Director</div>`,
    link: "https://www.linkedin.com/in/nupurgarg/",
  },
  
];


const ambassadors_team_current = [
    {
    imgUrl: iconnewamb6,
    name: "Cheshta Vashishth",
    desc: ``,
    post: "",
    designation: "Founder",
    company: "Uphill Education",
    link: "https://www.linkedin.com/in/cheshta-vashishth-72597b1ab/",
  },
  {
    imgUrl: iconnewamb4,
    name: "Kanak Heda",
    desc: ``,
    post: "",
    designation: "AVP",
    company: "Censie Capital Partners",
    link: "https://www.linkedin.com/in/kanak-heda-882662149/",
  },
  {
    imgUrl: iconnewamb1,
    name: "Kaushalya Venkataraman",
    desc: ``,
    post: "",
    designation: "Partner",
    company: "Chandhiok & Mahajan",
    link: "https://www.linkedin.com/in/kaushalyav/",
  },
   {
    imgUrl: iconnewamb3,
    name: "Nupur Nataraja",
    desc: ``,
    post: "",
    designation: "Associate, Asset Management",
    company: "Virtuous Retail ",
    link: "https://www.linkedin.com/in/nupur-nataraja-a1b21a16b/",
  },
  {
    imgUrl: iconnewamb2,
    name: "Pratiti Dasgupta",
    desc: ``,
    post: "",
    designation: "Consultant",
    company: "Avana Capital",
    link: "https://www.linkedin.com/in/pratiti-dasgupta-bb92671b1/",
  },
 
  
 

 
];

const ambassadors_team_previous = [
  {
    imgUrl: iconnewteam2,
    name: "Ayushi Vedwan",
    desc: ``,
    post: "",
    designation: "Lead - Brand Communications & Designing",
    company: "",
    link: "https://www.linkedin.com/in/ayushivedwan/",
  }, 
  {
    imgUrl: iconnewteam8,
    name: "Deeksha Jain",
    desc: ``,
    post: "",
    designation: "Manager Founder's Office",
    company: "",
    link: "https://www.linkedin.com/in/deekshajain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
  }, 
 {
    imgUrl: iconnewteam4,
    name: "Dr. Vijayta Mahendru",
    desc: ``,
    post: "",
    designation: "Manager: Business and Operations",
    company: "",
    link: "https://www.linkedin.com/in/vijayta-mahendru-phd-66421797/",
  }, 
    
   {
    imgUrl: iconnewteam6,
    name: "Prerna Jain",
    desc: ``,
    post: "",
    designation: "Program Manager",
    company: "",
    link: "https://linkedin.com/in/dr-prerna-jain-51519650",
  }, 
   
  
  {
    imgUrl: iconnewteam5,
    name: "Sudhanshu Khurana",
    desc: ``,
    post: "",
    designation: "Operations Associate",
    company: "",
    link: "https://www.linkedin.com/in/sudhanshu-khurana-622524194/",
  }, 
 {
    imgUrl: iconnewteam1,
    name: "Tina Ahluwalia",
    desc: ``,
    post: "",
    designation: "Director- Partnerships & Operations",
    company: "",
    link: "https://www.linkedin.com/in/tina-ahluwalia/",
  }, 
  
 
 
 
 
   
];

export { team_constants, team_constants1, ambassadors_team_current, ambassadors_team_previous };



// WEBPACK FOOTER //
// ./src/constant/team_constants.js